import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'setsEqual',
    standalone: true
})
export class SetsEqualPipe implements PipeTransform {
    transform<T>(a: Set<T>, b: Set<T>, equalFunction: Function = (a,b) => JSON.stringify(Array.from(a).sort()) === JSON.stringify(Array.from(b).sort())): boolean {
      return equalFunction(a,b)
    }
}

@Pipe({
    name: 'arraysEqual',
    standalone: true
})
export class ArraysEqualPipe implements PipeTransform {
    transform<T>(a: T[], b: T[], equalFunction: Function = (a,b) => JSON.stringify([...a].sort()) === JSON.stringify([...b].sort())): boolean {
      return equalFunction(a,b)
    }
}
